import React from 'react';
import PropTypes from 'prop-types';

// Material Design helpers
import { Typography, Box, Grid2 } from '@mui/material';

const NotFound = () => {
  return (
    <Box sx={{ padding: 4 }}>
      <Grid2
        container={true}
        justifyContent="center"
        spacing={4}
        sx={{ marginTop: '150px', textAlign: 'center' }}
      >
        <Grid2 item={true} lg={6} xs={12}>
          <Typography variant="h1" gutterBottom={true}>
            404: The page you are looking for isn’t here
          </Typography>
          <Typography variant="subtitle2" gutterBottom={true}>
            You either tried some shady route or you came here by mistake.
            Whichever it is, try using the navigation
          </Typography>
          <Box
            component="img"
            alt="Under development"
            src="/images/not_found.png"
            sx={{
              display: 'inline-block',
              marginTop: '50px',
              maxWidth: '100%',
              width: '554px',
            }}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

NotFound.propTypes = { classes: PropTypes.object };

export default NotFound;
